export default {
  ALPHABET_LIST: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K"],
  SQUARE: "square",
  CIRCLE: "circle",
};
